import { jsx as n, jsxs as d, Fragment as $ } from "react/jsx-runtime";
import g, { useState as U, useRef as x, useEffect as z, useContext as Y, useMemo as G, createContext as tt } from "react";
import { withManagedProps as A } from "@made-people/managed-props";
import { z as o } from "zod";
import { withZod as w } from "@made-people/react-prop-guard";
import { p as ot, a as et, b as j } from "./blueprint-3dc1fd04.mjs";
import { ProductCard as at, productCardPropsSchema as nt } from "@made-people/blueprint-product-card";
import { textBlockSchema as st, TextBlock as rt } from "@made-people/blueprint-text-block";
import { filterSchema as lt, Filter as W } from "@made-people/blueprint-filter";
import { LoadMore as it, loadMoreSchema as ct } from "@made-people/blueprint-load-more";
import { linkShortcutsSchema as pt, LinkShortcuts as mt } from "@made-people/blueprint-link-shortcuts";
import { overlayEventEmitter as T } from "@made-people/blueprint-overlay";
import { useTranslate as _ } from "@made-people/grease-translations";
import { StickyWrapper as q } from "@made-people/blueprint-sticky-wrapper";
import { useFacets as R, useSearchResultLoadMore as D, useSearchResultMeta as K, useSearchResultItems as ut } from "@made-people/grease-search";
import { ButtonAsButton as H, buttonContentPropsSchema as dt, Button as M, buttonAsLinkSchema as ht } from "@made-people/blueprint-button";
import { CrossIcon as bt, GridSizeSmallActiveIcon as ft, GridSizeSmallIcon as vt, GridSizeLargeActiveIcon as yt, GridSizeLargeIcon as St } from "@made-people/blueprint-icons";
import { componentWrapperSchema as O, ComponentWrapper as Pt } from "@made-people/blueprint-component-wrapper";
import { SkeletonCard as wt, skeletonCardSchema as Lt } from "@made-people/blueprint-skeleton-card";
import { ProductProvider as kt } from "@made-people/grease-product";
import { useReducedMotion as Ct, AnimatePresence as It, motion as At } from "motion/react";
import Nt from "clsx";
import "@made-people/blueprint";
const Z = o.object({
  enabled: o.boolean().optional(),
  showClearAll: o.boolean().optional(),
  icon: o.custom().optional(),
  buttonVariants: o.custom().optional(),
  clearButtonVariants: o.custom().optional()
}), Ft = A(
  "ActiveFilters",
  w(
    {
      schema: Z,
      defaultProps: {
        enabled: !1,
        showClearAll: !0,
        icon: /* @__PURE__ */ n(bt, {})
      }
    },
    ({ enabled: e, showClearAll: t, icon: a, buttonVariants: s, clearButtonVariants: c }) => {
      const { activeFacetValues: m, toggleFacet: i, resetFacets: u } = R(), l = _();
      return !e || m.length === 0 ? null : /* @__PURE__ */ d($, { children: [
        t && /* @__PURE__ */ n(
          H,
          {
            onClick: u,
            variants: {
              width: "auto",
              style: "solid",
              size: "sm",
              ...s,
              ...c
            },
            iconRight: a,
            label: l("Filter_Clear_All")
          }
        ),
        m.map((p) => /* @__PURE__ */ n(
          H,
          {
            iconRight: a,
            variants: {
              width: "auto",
              style: "solid",
              size: "sm",
              ...s
            },
            onClick: () => {
              i(p.facetId, p.id);
            },
            label: p.name
          },
          `${p.facetId}-${p.id}`
        ))
      ] });
    }
  )
), J = o.object({
  template: o.literal("montevideo"),
  trigger: o.custom().optional(),
  triggerIcon: o.custom().optional(),
  isSticky: o.boolean().optional(),
  variants: o.custom().optional(),
  activeFilters: Z.optional()
}), Bt = A(
  "ProductListHeaderMontevideo",
  w(
    {
      schema: J,
      defaultProps: {
        template: "montevideo",
        isSticky: !0
      }
    },
    ({ variants: e, triggerIcon: t, isSticky: a, activeFilters: s }) => {
      const c = g.useContext(N), { paginationStats: m } = D(), i = ot.styles(e), u = _(), l = K();
      if (!c)
        return null;
      const { filter: p } = c, r = t;
      return /* @__PURE__ */ d(a ? q : "div", { className: i.base, children: [
        (p == null ? void 0 : p.enabled) && /* @__PURE__ */ d(
          "button",
          {
            className: i.filterTrigger,
            onClick: () => T.emit("open", { overlayId: "filter" }),
            children: [
              r && /* @__PURE__ */ n(r, { className: i == null ? void 0 : i.filterTriggerIcon }),
              u("Filter_Trigger")
            ]
          }
        ),
        (s == null ? void 0 : s.enabled) && /* @__PURE__ */ n("div", { className: i.activeFilters, children: /* @__PURE__ */ n(Ft, { ...s }) }),
        l && /* @__PURE__ */ n("span", { className: i.headerProducts, children: u("Filter_Amount_Of_Products", {
          totalProducts: l.totalItems,
          seenProducts: m.seen
        }) })
      ] });
    }
  )
), gt = (e) => {
  const [t, a] = U(!1), s = x(null);
  return z(() => {
    if (e != null && e.current) {
      s.current = e.current.getBoundingClientRect().top + window.scrollY;
      let c = 0, m = !1;
      const i = () => {
        c = window.scrollY, m || (window.requestAnimationFrame(() => {
          s.current && (a(c > s.current), m = !1);
        }), m = !0);
      };
      return window.addEventListener("scroll", i, { passive: !0 }), () => {
        window.removeEventListener("scroll", i);
      };
    }
  }, [e]), t;
}, Q = o.object({
  template: o.literal("salto"),
  trigger: o.custom().optional(),
  buttonVariants: dt.shape.variants.optional(),
  setItemsPerRow: o.custom().optional(),
  toggleGridSize: o.object({
    enabled: o.boolean().optional(),
    small: o.object({
      label: o.string().optional(),
      icons: o.object({
        active: o.custom().optional(),
        inactive: o.custom().optional()
      }).optional()
    }).optional(),
    large: o.object({
      label: o.string().optional(),
      icons: o.object({
        active: o.custom().optional(),
        inactive: o.custom().optional()
      }).optional()
    }).optional()
  }).optional(),
  variants: o.custom().optional(),
  hideStickyFilterButtonBeforeScroll: o.boolean().optional()
}), jt = A(
  "ProductListHeaderSalto",
  w(
    {
      schema: Q,
      defaultProps: {
        template: "salto",
        toggleGridSize: {
          enabled: !1,
          small: {
            label: "Toggle Small Grid Size",
            icons: {
              active: /* @__PURE__ */ n(ft, {}),
              inactive: /* @__PURE__ */ n(vt, {})
            }
          },
          large: {
            label: "Toggle Large Grid Size",
            icons: {
              active: /* @__PURE__ */ n(yt, {}),
              inactive: /* @__PURE__ */ n(St, {})
            }
          }
        },
        hideStickyFilterButtonBeforeScroll: !0
      }
    },
    ({
      variants: e,
      buttonVariants: t,
      toggleGridSize: a,
      hideStickyFilterButtonBeforeScroll: s
    }) => {
      var F, f, k, B, S, C, I, v, P, E;
      const c = et.styles(e), m = _(), i = K(), { paginationStats: u } = D(), { activeFacetValues: l } = R(), p = l == null ? void 0 : l.length, r = g.useContext(N), h = !s || gt(r == null ? void 0 : r.productListRef);
      if (!r)
        return null;
      const { filter: b, setGridSize: y, gridSize: L } = r;
      return /* @__PURE__ */ d($, { children: [
        (b == null ? void 0 : b.enabled) && /* @__PURE__ */ n(
          "div",
          {
            className: c.stickyFilterTrigger,
            "data-is-pinned": h,
            children: /* @__PURE__ */ n(
              M,
              {
                as: "button",
                onClick: () => T.emit("open", { overlayId: "filter" }),
                variants: {
                  color: "primary",
                  size: "md",
                  ...t
                },
                label: m("Filter_Trigger", {
                  activeFiltersLength: p ? `(${p})` : ""
                })
              }
            )
          }
        ),
        /* @__PURE__ */ d(q, { className: c.base, children: [
          (b == null ? void 0 : b.enabled) && /* @__PURE__ */ n(
            M,
            {
              as: "button",
              className: c.filterTrigger,
              onClick: () => T.emit("open", { overlayId: "filter" }),
              variants: {
                color: "primary",
                size: "md",
                ...t
              },
              label: m("Filter_Trigger", {
                activeFiltersLength: p ? `(${p})` : ""
              })
            }
          ),
          (a == null ? void 0 : a.enabled) && /* @__PURE__ */ d("div", { className: c.toggleGridSize, children: [
            /* @__PURE__ */ n(
              "button",
              {
                className: c.toggleGridSizeButton,
                "aria-label": (F = a == null ? void 0 : a.small) == null ? void 0 : F.label,
                onClick: () => y("small"),
                children: L === "small" ? (k = (f = a == null ? void 0 : a.small) == null ? void 0 : f.icons) == null ? void 0 : k.active : (S = (B = a == null ? void 0 : a.small) == null ? void 0 : B.icons) == null ? void 0 : S.inactive
              }
            ),
            /* @__PURE__ */ n(
              "button",
              {
                className: c.toggleGridSizeButton,
                "aria-label": (C = a == null ? void 0 : a.large) == null ? void 0 : C.label,
                onClick: () => y("large"),
                children: L === "large" ? (v = (I = a == null ? void 0 : a.large) == null ? void 0 : I.icons) == null ? void 0 : v.active : (E = (P = a == null ? void 0 : a.large) == null ? void 0 : P.icons) == null ? void 0 : E.inactive
              }
            )
          ] }),
          /* @__PURE__ */ n("span", { className: c.headerProducts, children: i && m("Filter_Amount_Of_Products", {
            totalProducts: i.totalItems,
            seenProducts: u.seen
          }) })
        ] })
      ] });
    }
  )
), V = o.discriminatedUnion("template", [
  J.extend({
    template: o.literal("montevideo")
  }),
  Q.extend({
    template: o.literal("salto")
  })
]), Tt = w(V, (e) => {
  switch (e.template) {
    case "montevideo":
      return /* @__PURE__ */ n(Bt, { ...e });
    case "salto":
      return /* @__PURE__ */ n(jt, { ...e });
    default:
      return null;
  }
}), Mt = "montevideo", X = o.object({
  isEnabled: o.boolean().optional(),
  templateProps: V.optional()
}), _t = A(
  "ProductListHeader",
  w(
    {
      schema: X,
      defaultProps: {
        isEnabled: !0
      }
    },
    (e) => {
      const t = e.templateProps || {
        template: Mt
      };
      return e.isEnabled ? /* @__PURE__ */ n(Tt, { ...t }) : null;
    }
  )
), Rt = () => {
  const e = Y(N), t = ut(), { activeFacetValues: a } = R();
  return G(() => {
    var u;
    if (!t || !(e != null && e.contentSections) || e.contentSections.length === 0)
      return t;
    const s = ((u = e.contentSectionsSettings) == null ? void 0 : u.hideWhenFiltered) ?? !1, c = a.length > 0;
    if (s && c)
      return t;
    const m = [...t];
    return e.contentSections.filter(
      (l) => l.position >= 0 && l.position <= m.length
    ).sort((l, p) => p.position - l.position).forEach((l) => {
      m.splice(l.position, 0, {
        type: "component",
        data: l.content,
        columnSpan: l.columnSpan,
        rowSpan: l.rowSpan
      });
    }), m;
  }, [
    t,
    e == null ? void 0 : e.contentSections,
    e == null ? void 0 : e.contentSectionsSettings,
    a
  ]);
}, Et = () => {
  var u, l, p;
  const e = Rt(), t = Y(N), a = j.styles(t == null ? void 0 : t.variants), s = t == null ? void 0 : t.filter, c = Ct(), m = 4, i = (r) => (s == null ? void 0 : s.enabled) && (Array.isArray(s.as) ? s.as.includes(r) : s.as === r);
  return /* @__PURE__ */ d(
    "div",
    {
      className: Nt(
        a.list,
        // For large screens, we need to switch to two columns if the filter is set to "column".
        // TODO: Rewrite
        i("column") ? "lg:col-start-2" : "lg:col-start-1"
      ),
      children: [
        !e && Array.from(
          {
            length: ((u = t == null ? void 0 : t.fallback) == null ? void 0 : u.amountOfItems) ?? ((l = t == null ? void 0 : t.fallback) == null ? void 0 : l.amountOfItems) ?? 12
          },
          (r, h) => /* @__PURE__ */ n("div", { className: a.item, children: /* @__PURE__ */ n(wt, { ...t == null ? void 0 : t.skeletonCard }) }, h)
        ),
        /* @__PURE__ */ n(It, { mode: "popLayout", children: e && e.map((r, h) => {
          const b = !c && h >= m, y = r.type === "component" && r.columnSpan && r.rowSpan ? j.styles({
            columnSpan: r.columnSpan,
            rowSpan: r.rowSpan
          }).item : a.item;
          return /* @__PURE__ */ n(
            At.div,
            {
              className: y,
              ...b ? {
                initial: { opacity: 0 },
                whileInView: { opacity: 1 },
                viewport: { once: !0, amount: 0.2 },
                transition: { duration: 0.25, ease: "easeOut" }
              } : {},
              exit: { opacity: 0 },
              children: r.type === "product" ? /* @__PURE__ */ n(
                kt,
                {
                  product: r.product,
                  context: {
                    type: "plp",
                    position: h
                  },
                  children: typeof (t == null ? void 0 : t.component) == "object" ? t.component : /* @__PURE__ */ n(at, { ...t == null ? void 0 : t.productCard })
                }
              ) : r.type === "component" ? r.data : null
            },
            `product-${h}`
          );
        }) }),
        e && /* @__PURE__ */ n(
          it,
          {
            buttonVariants: {
              color: "black",
              style: "outline"
            },
            ...t == null ? void 0 : t.loadMore,
            className: a.loadMore
          }
        ),
        ((p = t == null ? void 0 : t.linkBelowList) == null ? void 0 : p.label) && /* @__PURE__ */ n(
          M,
          {
            as: "a",
            className: a.linkBelowList,
            ...t.linkBelowList
          }
        )
      ]
    }
  );
}, Wt = o.object({
  variants: o.custom().optional(),
  layout: O.shape.layout.optional(),
  productCard: nt.optional(),
  skeletonCard: Lt.optional(),
  component: o.custom().optional(),
  loadMore: ct.optional(),
  linkBelowList: ht.optional(),
  fallback: o.object({
    enabled: o.boolean().optional(),
    amountOfItems: o.number().optional()
  }).optional(),
  filter: o.object({
    enabled: o.boolean().optional(),
    as: o.union([
      o.enum(["drawer", "stacked", "column"]),
      o.array(o.enum(["drawer", "stacked", "column"]))
    ]).optional(),
    settings: lt.optional()
  }).optional(),
  header: X.optional(),
  textBlocks: st.array().optional(),
  shortcutNav: pt.array().optional(),
  contentSections: o.array(
    o.object({
      position: o.number(),
      content: o.any(),
      columnSpan: o.custom().optional(),
      rowSpan: o.custom().optional()
    })
  ).optional(),
  contentSectionsSettings: o.object({
    hideWhenFiltered: o.boolean().optional()
  }).optional()
}).merge(O), N = tt(void 0), lo = A(
  "ProductList",
  w(
    {
      schema: Wt,
      defaultProps: {
        fallback: {
          enabled: !0,
          amountOfItems: 12
        },
        loadMore: {
          enabled: !0
        },
        filter: {
          as: "drawer"
        }
      }
    },
    ({
      variants: e,
      filter: t,
      fallback: a,
      loadMore: s,
      header: c,
      layout: m,
      shortcutNav: i,
      textBlocks: u,
      component: l,
      linkBelowList: p,
      skeletonCard: r,
      contentSections: h,
      contentSectionsSettings: b,
      ...y
    }) => {
      const L = g.useRef(null), F = g.useRef(null), f = j.styles(e), [k, B] = U("small"), S = (v) => (t == null ? void 0 : t.enabled) && (Array.isArray(t.as) ? t.as.includes(v) : t.as === v), C = Array.isArray(u) && u.length > 0, I = Array.isArray(i) && i.length > 0;
      return /* @__PURE__ */ d(
        N.Provider,
        {
          value: {
            filter: t,
            variants: e,
            fallback: a,
            loadMore: s,
            skeletonCard: r,
            gridSize: k,
            component: l,
            setGridSize: B,
            productListRef: L,
            linkBelowList: p,
            contentSections: h,
            contentSectionsSettings: b,
            ...y
          },
          children: [
            /* @__PURE__ */ d(
              Pt,
              {
                elementRef: F,
                className: f.base,
                layout: { ...m },
                ...y,
                children: [
                  (C || I) && /* @__PURE__ */ d("div", { className: f.descriptionWrapper, children: [
                    C && u.map((v, P) => /* @__PURE__ */ n(
                      rt,
                      {
                        ...v,
                        layout: {
                          spacing: { applySpacing: "false" },
                          position: { applyPosition: "false" }
                        },
                        className: f.description
                      },
                      P
                    )),
                    I && i.map((v, P) => /* @__PURE__ */ n(
                      mt,
                      {
                        ...v,
                        className: f.shortcutNav,
                        layout: {
                          spacing: {
                            applySpacing: "false"
                          },
                          position: { applyPosition: "false" }
                        }
                      },
                      P
                    ))
                  ] }),
                  /* @__PURE__ */ d(
                    "div",
                    {
                      className: f.grid,
                      "data-grid-size": k,
                      ref: L,
                      children: [
                        /* @__PURE__ */ n(_t, { ...c }),
                        (S("stacked") || S("column")) && /* @__PURE__ */ n(W, { ...t == null ? void 0 : t.settings, className: f.filter }),
                        /* @__PURE__ */ n(Et, {})
                      ]
                    }
                  )
                ]
              }
            ),
            S("drawer") && /* @__PURE__ */ n(W, { ...t == null ? void 0 : t.settings, as: "drawer" })
          ]
        }
      );
    }
  )
);
export {
  Ft as ActiveFilters,
  Et as List,
  Bt as Montevideo,
  lo as ProductList,
  N as ProductListContext,
  _t as ProductListHeader,
  jt as Salto,
  Tt as TemplateSelector,
  Z as activeFiltersSchema,
  J as montevideoSchema,
  X as productListHeaderSchema,
  Wt as productListSchema,
  Q as saltoSchema,
  V as templateSelectorSchema,
  gt as usePinHeader,
  Rt as useProductListItems
};
//# sourceMappingURL=index.es.js.map
